import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {

  constructor() { }

  takePhoto(sourceType: any): Promise<any> {
    return;
  }

  getCameraProviderResponse(path: string) {
    return {
      success: true,
      mediaPath: path,
    };
  }

  public async addNewToGallery(source: CameraSource): Promise<Photo> {
    // Take a photo
    const capturedPhoto = await Camera.getPhoto({
      quality: 50,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: source,
      correctOrientation: true,
      saveToGallery: false,
    });
    return capturedPhoto;
  }

  public base64ToArrayBuffer(imageData: any) {
    const binary_string = atob(imageData);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
}
